import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@axios';

// Modules
import CallListModule from '@/store/modules/CallListModule';
import PrisonModule from '@/store/modules/PrisonModule';
import CallDetailsModule from '@/store/modules/CallDetailsModule';
import AdditionalParticipantsModule from '@/store/modules/AdditionalParticipantsModule';
import VisitorModule from '@/store/modules/VisitorModule';
import BookingSlotsModule from '@/store/modules/bookingSlotsModule';
import statsModule from '@/store/modules/statsModule';
import socialVisitsModule from '@/store/modules/SocialVisitsModule';
import SocialBookingSlotsModule from '@/store/modules/SocialBookingSlotsModule';
import InCellVisitsModule from '@/store/modules/InCellVisitsModule';
import InCellBookingSlotsModule from '@/store/modules/InCellBookingSlotsModule';
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import AuthModule from './modules/AuthModule';
import Booking from './modules/bookingModule';
import { REST_ENDPOINT, REST_ENDPOINT_AU } from '../../endpoints';

const regionKey = 'userRegion';
const endpointKey = 'restEndpoint';
const userPermissionsKey = 'userPermissions';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    region: 'UK',
    permissions: JSON.parse(localStorage.getItem(userPermissionsKey)) || {},
  },
  mutations: {
    SET_REGION(state, value) {
      state.region = value;
      localStorage.setItem(regionKey, value);

      if (value === 'UK') {
        localStorage.setItem(endpointKey, REST_ENDPOINT);
      } else if (value === 'Australia') {
        localStorage.setItem(endpointKey, REST_ENDPOINT_AU);
      } else { // default
        localStorage.setItem(endpointKey, REST_ENDPOINT);
      }

      axios.defaults.baseURL = localStorage.getItem(endpointKey);
    },
    SET_PERMISSIONS(state, permissions) {
      localStorage.setItem(userPermissionsKey, JSON.stringify(permissions));
      state.permissions = permissions;
    },
  },
  actions: {
    setRegionFromLocal({ commit, state }) {
      const region = localStorage.getItem(regionKey);

      commit('SET_REGION', region || state.region);
    },
    setPermissions({ commit }, permissions) {
      localStorage.setItem(userPermissionsKey, JSON.stringify(permissions));
      commit('SET_PERMISSIONS', permissions);
    },
  },
  modules: {
    app,
    appConfig,
    verticalMenu,
    auth: AuthModule,
    callList: CallListModule,
    prison: PrisonModule,
    callDetails: CallDetailsModule,
    participants: AdditionalParticipantsModule,
    visitor: VisitorModule,
    booking: Booking,
    bookingSlots: BookingSlotsModule,
    stats: statsModule,
    socialVisits: socialVisitsModule,
    socialBookingSlots: SocialBookingSlotsModule,
    inCellVisits: InCellVisitsModule,
    inCellBookingSlots: InCellBookingSlotsModule,
  },
  strict: process.env.DEV,
})
